var eventStopPropagation = function eventStopPropagation(event) {
  event.stopPropagation();
};
var eventPreventDefault = function eventPreventDefault(event) {
  event.preventDefault();
};

export { eventPreventDefault, eventStopPropagation };
//# sourceMappingURL=index.js.map
